import React, { useState, useEffect } from "react";
import "../components/BetterWMS";
import "../components/BetterWMSRaster";
import { renderToString } from "react-dom/server";
import * as L from "leaflet";
import "leaflet-geoserver-request";
import "leaflet-groupedlayercontrol";
import { GEOSERVER_API_URL } from "../../../actions/types";
import basemaps from "../components/basemaps";
import "../components/leaflet-slider/leaflet-slider";
import "../components/leaflet-color-control/leaflet-color-control";
import "../components/leaflet-search-coordinates/leaflet-search-coordinates";
import "../components/leaflet-reccomended";
import chroma from "chroma-js";
import { Button } from "reactstrap";
import { getInputData } from "../../../actions/data";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { tokenConfig } from "../../../utils/tokenConfig";
import axios from "axios";
import { API_URL } from "../../../actions/types";

var map = null;
export const FixedOpt = (props) => {
  const [showInput, setShowInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory();

  const styleBtnInputData = {
    zIndex: 999,
    position: "absolute",
    top: 10,
    left: "40%",
    padding: "3px 12px",
    boxShadow: "none",
  };

  const rainbowScale = chroma.scale([
    "#2b83ba",
    "#abdda4",
    "#ffffbf",
    "#fdae61",
    "#d7191c",
  ]);
  const blueScale = chroma.scale(["#f7fbff", "#08306b"]);
  const greenScale = chroma.scale(["#f7fcf5", "#00441b"]);

  const getLegendHTML = (scale) =>
    renderToString(
      <div id="legend">
        <div
          className="row mb-2"
          style={{
            minWidth: 0,
          }}
        >
          <span
            className="m-auto"
            style={{
              fontWeight: "bold",
            }}
          >
            Production fixed axis (optimal °) (kWh/m2)
          </span>
        </div>
        <div className="row">
          <div
            className="col-12"
            id="legend-colors"
            style={{
              display: "flex",
              flexDirection: "row",
              paddingLeft: 24,
              paddingRight: 24,
              justifyContent: "center",
            }}
          >
            {Array(100)
              .fill(0)
              .map((color, index) => {
                return (
                  <div
                    style={{
                      height: 25,
                      width: 3,
                      backgroundColor: scale(index / 100).hex(),
                    }}
                  />
                );
              })}
          </div>
        </div>
        <div className="row mt-1">
          <div
            className="col-3"
            style={{
              display: "flex",
              paddingLeft: 24,
              paddingRight: 24,
            }}
          >
            0
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              paddingLeft: 24,
              paddingRight: 24,
            }}
          >
            1000
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              paddingLeft: 24,
              paddingRight: 24,
              justifyContent: "center",
            }}
          >
            2000
          </div>
          <div
            className="col-3"
            style={{
              display: "flex",
              paddingLeft: 24,
              paddingRight: 24,
              justifyContent: "flex-end",
            }}
          >
            3000
          </div>
        </div>
      </div>
    );

  const mapPopup = (properties) => {
    console.log(properties)
    return renderToString(
      <div className="row text-center px-2">
        <div
          className="col-12 mb-2 mt-1 text-center"
          style={{ fontWeight: "bolder" }}
        >
          {properties.name.toUpperCase()}
        </div>
        <div className="col-12 mb-1">
          Fixed optimal: {properties.fixed_opt.toFixed(2)}
        </div>
      </div>
    );
  };

  // Country layer
  const countriesLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:countries",
      tiled: true,
      format: "image/png",
      transparent: true,
      styles: "fixed_opt_rainbow",
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );
  // Region layer
  const regionsLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:regions",
      tiled: true,
      format: "image/png",
      transparent: true,
      styles: "fixed_opt_rainbow",
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );
  // Region layer
  const districtsLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:districts",
      tiled: true,
      format: "image/png",
      transparent: true,
      styles: "fixed_opt_rainbow",
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );

  // GRID layer
  const gridLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:points",
      tiled: true,
      format: "image/png",
      transparent: true,
      styles: "fixed_opt_rainbow_grid",
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );

  const torinoLayer = L.tileLayer.betterWms(
    GEOSERVER_API_URL,
    {
      layers: "res:torino",
      tiled: true,
      format: "image/png",
      transparent: true,
      styles: "fixed_opt_rainbow_grid",
      version: "1.3.0",
      opacity: 1,
      height: 256,
      width: 256,
    },
    mapPopup
  );

  // Basemaps + Layers
  const groupLayer = L.control.groupedLayers(
    {
      Light: basemaps[0],
      Classico: basemaps[1],
      Topologia: basemaps[2],
      Satellite: basemaps[3],
      Fisica: basemaps[4],
    },
    {
      Layers: {
        Countries: countriesLayer,
        Regions: regionsLayer,
        Districts: districtsLayer,
        Point: gridLayer,
        Torino: torinoLayer,
      },
    },
    {
      exclusiveGroups: ["Layers"],
    }
  );

  // OPACITY SLIDER
  const opacitySlider = L.control.slider(
    (value) => {
      countriesLayer.setOpacity(value / 100);
      regionsLayer.setOpacity(value / 100);
      districtsLayer.setOpacity(value / 100);
      gridLayer.setOpacity(value / 100);
      torinoLayer.setOpacity(value / 100);
    },
    {
      id: "slider",
      orientation: "horizontal",
      position: "bottomleft",
      min: 0,
      max: 100,
      width: 400,
      value: 100,
      logo: "O",
    }
  );
  // Recommended
  const recommendedAreasControl = L.control.recommendedAreas([
    countriesLayer,
    regionsLayer,
    districtsLayer,
    gridLayer,
  ]);
  // Color
  const colorControl = L.control.color(
    (colors) => {
      var scale = null;
      switch (colors) {
        case "rainbow":
          scale = rainbowScale;
          break;
        case "blue":
          scale = blueScale;
          break;
        case "green":
          scale = greenScale;
          break;

        default:
          scale = rainbowScale;
          break;
      }
      document.getElementById("legend").innerHTML = getLegendHTML(scale);
      countriesLayer.setParams({
        styles: `fixed_opt_${colors}`,
      });
      regionsLayer.setParams({
        styles: `fixed_opt_${colors}`,
      });
      districtsLayer.setParams({
        styles: `fixed_opt_${colors}`,
      });
      gridLayer.setParams({
        styles: `fixed_opt_${colors}_grid`,
      });
      torinoLayer.setParams({
        styles: `fixed_opt_${colors}_grid`,
      });
    },
    {
      default: "multicolor",
    }
  );

  // LEGEND
  var legend = L.control({ position: "bottomleft" });
  legend.onAdd = (map) => {
    var div = L.DomUtil.create("div", "info legend");
    div.style.backgroundColor = "white";
    div.style.padding = "8px";
    div.style.marginBottom = "25px";
    div.style.borderRadius = "4px";
    div.style.boxShadow = "0 1px 5px rgba(0,0,0,0.65)";

    div.innerHTML = getLegendHTML(rainbowScale);
    return div;
  };

  const searchCoordinates = L.control.searchCoordinates();

  useEffect(() => {
    if (map === null) {
      map = L.map("map", {
        zoomSnap: 1,
        minZoom: 2,
        layers: [basemaps[0], countriesLayer],
        preferCanvas: true,
        maxBoundsViscosity: 1,
      }).setView([55, 75], 3);

      map.on('overlayadd', (e) => {
        if (e.name === 'Torino') {
          map.setView([45.066153, 7.663324], 12);
        }
      });


      map.doubleClickZoom.disable();

      legend.addTo(map);
      recommendedAreasControl.setPosition("bottomleft").addTo(map);
      opacitySlider.addTo(map);
      groupLayer.setPosition("topleft").addTo(map);
      colorControl.setPosition("bottomleft").addTo(map);
      searchCoordinates.setPosition("bottomright").addTo(map);
    }

    if (showInput === true) {
      async function getData() {
        setIsLoading(true);
        const listCoordinates = await axios.get(
          `${API_URL}/points/sardegna/`,
          tokenConfig()
        );
        setIsLoading(false);
        var markers_group = L.markerClusterGroup({
          iconCreateFunction: function (cluster) {
            return L.divIcon({
              html:
                "<div style='height:25px;width:25px;background-color:#8EBBF3;border-radius:50%;margin-left:-10px;margin-top:-10px'>" +
                "<div style='text-align:center;padding-top:3px'>" +
                cluster.getChildCount() +
                "</div>" +
                "</div>",
            });
          },
          disableClusteringAtZoom: 12,
          spiderfyOnMaxZoom: false,
        });
        listCoordinates.data.forEach((coord) => {
          var marker = L.marker([coord.lat, coord.long]).on("click", (e) => {
            props.getInputData(
              e.target._latlng.lat,
              e.target._latlng.lng,
              history
            );
          });
          markers_group.addLayer(marker);
        });
        markers_group.addTo(map);
      }
      getData();
    } else {
      map.eachLayer(function (layer) {
        if (layer instanceof L.MarkerClusterGroup) {
          map.removeLayer(layer);
        }
      });
    }
  }, [showInput]);

  // remove map and set main var to null
  useEffect(() => {
    return () => {
      map.off();
      map.remove();
      map = null;
    };
  }, []);

  return (
    <React.Fragment>
      <div id="map" style={{ height: "100%", width: "100%" }}></div>
      {isLoading === true ? (
        <Button color="warning" style={styleBtnInputData}>
          Loading...
        </Button>
      ) : showInput === false ? (
        <Button
          color="primary"
          style={{
            ...styleBtnInputData,
            backgroundColor: "#49B2F5",
            borderColor: "#49B2F5",
          }}
          onClick={() => {
            setShowInput(true);
          }}
        >
          View input data
        </Button>
      ) : (
        <Button
          color="secondary"
          style={styleBtnInputData}
          onClick={() => {
            setShowInput(false);
          }}
        >
          Hide input data
        </Button>
      )}
    </React.Fragment>
  );
};

export default connect(null, { getInputData })(FixedOpt);
